module.exports = __webpack_public_path__ + "img/05.74251469.png";